import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { Divider } from "antd";
import TabelaPadrao from "../../components/TabelaPadrao";
import { DelIcon, LabelPadrao, LegendaEntrega, LoadingContainerPadrao, OkIcon } from "../../components/Base";
import { useFetch } from "../../components/Hooks/Conexao";
import { BtnLink } from "../../components/Buttons";

function VendaDetalhesOutros({ vendaId, setTitulo, setVendaId, setPreVendaId, isLocal, ...props }) {
  const [detalhe, listar, loading] = useFetch(() => props.fetch().post(`venda/consulta/outros`, { id: vendaId, isLocal }), null);

  useEffect(() => listar(), []);

  return <LoadingContainerPadrao style={{ minHeight: 300 }} loading={loading}>

    {!!detalhe?.vendaOrigem && <LabelPadrao noMargin>Venda origem: <BtnLink onClick={() => setVendaId(detalhe.vendaOrigem.id)}>Nº {detalhe.vendaOrigem.numero}</BtnLink></LabelPadrao>}
    {(!detalhe?.isEntrega && !!detalhe?.preVendas?.length) && <LabelPadrao noMargin>Pré-venda: <BtnLink onClick={() => setPreVendaId(detalhe.preVendas[0].id)}>Nº {detalhe.preVendas[0].numero}</BtnLink></LabelPadrao>}

    {(detalhe?.isEntrega && detalhe?.preVendas?.length) && <>
      <Divider orientation="left">Entregas Nº {detalhe.preVendas[0].numero}</Divider>

      {detalhe.preVendas.map(x => <div key={x.id} style={{ display: "flex", alignItems: "center" }}>
        <BtnLink onClick={() => setPreVendaId(x.id)}>{x.entrega?.bairro}</BtnLink>
        <LegendaEntrega status={x.entrega?.status} />
      </div>)}
    </>}

    {!!detalhe?.devolucoes?.length && <>
      <Divider orientation="left">Devoluções</Divider>
      <TabelaPadrao columns={columnsDetDev} data={detalhe.devolucoes} setDetalhe={v => setVendaId(v.id)} />
    </>}

    {!!detalhe?.movimentos?.length && <>
      <Divider orientation="left">Movimentos caixa</Divider>
      <TabelaPadrao columns={columnsMovs} data={detalhe.movimentos} />
    </>}

    {!!detalhe?.crediarios?.length && <>
      <Divider orientation="left">Crediários</Divider>
      <TabelaPadrao columns={columnsTitulos} data={detalhe.crediarios} />
    </>}

  </LoadingContainerPadrao>;
}

export default connect(null, { fetch })(VendaDetalhesOutros);

const columnsMovs = [
  {
    Header: "Tipo",
    accessor: "tipo",
  },
  {
    Header: "Usuário",
    accessor: "usuario"
  },
  {
    Header: "Data",
    accessor: "data",
    tipo: "dthr",
  },
  {
    Header: "Valor",
    accessor: "valor",
    tipo: "rs"
  }
];

const columnsTitulos = [
  {
    Header: "Número",
    accessor: "numero",
    Footer: " "
  },
  {
    Header: "Plano de contas",
    accessor: "planoConta"
  },
  {
    Header: "Vencimento",
    accessor: "venc",
    tipo: "dt",
  },
  {
    Header: "Valor",
    accessor: "valor",
    tipo: "rs",
    Somar: true
  },
  {
    Header: "Valor pago",
    accessor: "valorPago",
    tipo: "rs",
    Somar: true
  }
];

const columnsDetDev = [
  {
    Header: "Data",
    accessor: "data",
    tipo: "dthr",
    Footer: " ",
  },
  {
    Header: "Status",
    accessor: "status",
    tipo: "center",
    Cell: props => {
      const isCancelada = !!props.row.original.dataCancela;
      if (isCancelada)
        return <DelIcon />;
      else
        return <OkIcon />;
    }
  },
  {
    Header: "Valor total",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true
  }
];